import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';
import { DateItem } from '../showtime-streaming-in-cinemas/performance/performance.component';

@Component({
    selector: 'ush-ui-date',
    styleUrls: ['./ui-date.component.scss'],
    template: `
    <span class="day-literal">{{ date?.dayLiteral }}</span>
    <span class="date-literal">{{ date?.dateLiteral }}</span>
  `,
    standalone: false
})
export class UiDateComponent {
  @HostBinding('type') type = 'button';
  @HostBinding('role') role = 'button';
  @HostBinding('tabindex') tabindex = '0';
  @HostBinding('class.active') get activeClass() {
    return this.date.active;
  }

  private _date: DateItem;
  get date(): DateItem {
    return this._date;
  }
  @Input() set date(date: DateItem) {
    this._date = date;
  }

  @Output() dateSelected = new EventEmitter<DateItem>();

  @HostListener('click') onClick() {
    this.dateSelected.emit(this.date);
    this.date.active = true;
  }

  @HostListener('keydown.enter') onEnter() {
    this.dateSelected.emit(this.date);
    this.date.active = true;
  }
}
